














export default
  props:
    point:
      type: Number
    comment:
      type: String
    className:
      type: String
